import createClient from '../../apolloClient';
import MUTATION_CREATE_USER from '../../mutation/createUser';

const handleCreateUser = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_CREATE_USER,
    variables,
  });
  const { createUser } = result?.data || {};
  return createUser;
};

export default handleCreateUser;
